(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["juizs-consent"] && !Shopify.designMode) return;
  try {
    (function () {
    // juizs-consent — foutmelding bij het verplichte vakje. Gedelegeerd op
    // document, dus ook geldig voor secties die de editor opnieuw laadt.
    // 'invalid' bubbelt niet: daarom luisteren in de capture-fase.
    function consentError(box) {
      var id = box.getAttribute('data-juizs-consent');
      return id ? document.getElementById(id) : null;
    }
    function isConsent(el) {
      return !!(el && el.nodeType === 1 && el.hasAttribute('data-juizs-consent'));
    }
    document.addEventListener('invalid', function (event) {
      var box = event.target;
      if (!isConsent(box)) return;
      var error = consentError(box);
      if (!error) return;
      // Geen browserballon: onze melding staat vast in het foutvlak. Het
      // formulier blijft geblokkeerd — dat doet de validatie, niet deze regel.
      event.preventDefault();
      error.hidden = false;
      box.setAttribute('aria-invalid', 'true');
      box.setAttribute('aria-describedby', error.id);
      // Is er vóór het vakje nog een ongeldig veld, dan meldt de browser dat
      // veld en zet hij de focus daar. Anders gaat de focus naar het vakje.
      var firstInvalid = box.form ? box.form.querySelector(':invalid') : box;
      if (firstInvalid === box) box.focus();
    }, true);
    document.addEventListener('change', function (event) {
      var box = event.target;
      if (!isConsent(box) || !box.checked) return;
      var error = consentError(box);
      if (error) error.hidden = true;
      box.removeAttribute('aria-invalid');
      box.removeAttribute('aria-describedby');
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["juizs-password-chrome"] && !Shopify.designMode) return;
  try {
    (function () {
    // juizs-password-chrome (golf 6d) — een link met data-juizs-pw-reveal die
    // naar een uitklapper met data-juizs-pw-disclosure wijst ("Wachtwoord" →
    // het wachtwoordveld, de toestemmingsregel → het privacybeleid), klapt die
    // open en zet de focus erin: het veld met data-juizs-pw-focus, anders de
    // summary. Zonder JS springt de link naar de uitklapregel. Andere links
    // en pagina's raakt dit niet.
    function disclosureFor(hash) {
      if (!hash || hash.length < 2) return null;
      var el;
      try {
        el = document.getElementById(decodeURIComponent(hash.slice(1)));
      } catch (e) {
        return null;
      }
      if (!el) return null;
      var details = el.tagName === 'DETAILS' ? el : el.closest('details');
      return details && details.hasAttribute('data-juizs-pw-disclosure') ? details : null;
    }
    document.addEventListener('click', function (event) {
      var link = event.target && event.target.closest ? event.target.closest('a[data-juizs-pw-reveal]') : null;
      if (!link) return;
      var details = disclosureFor(link.hash);
      if (!details) return;
      event.preventDefault();
      details.open = true;
      // Het veld naar het midden, het beleid met de kop bovenaan in beeld
      // (focus() alleen scrolt tot net binnen de rand — gemeten op 390px).
      // Hier is de paginasprong de bedoeling: de link is een anker, en zonder
      // JS springt de browser er ook heen. (Anders dan bij scrollrijen, waar
      // scrollIntoView een ongewenste sprong geeft.)
      var field = details.querySelector('[data-juizs-pw-focus]');
      var target = field || details.querySelector('summary');
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (target) target.focus({ preventScroll: true });
      details.scrollIntoView({ block: field ? 'center' : 'start', behavior: still ? 'auto' : 'smooth' });
    });
    // Binnenkomen met #juizs-pw-toegang of #juizs-pw-privacy in de URL
    function openFromHash() {
      var details = disclosureFor(window.location.hash);
      if (details) details.open = true;
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openFromHash);
    } else {
      openFromHash();
    }
    window.addEventListener('hashchange', openFromHash);
  })();
  } catch(e) { console.error(e); }
})();

})();
